/**
 * Formats raw input as a BR phone number mask while typing: `(xx) xxxxx-xxxx`
 * for 11-digit mobile numbers, `(xx) xxxx-xxxx` for 10-digit landlines, and a
 * progressively-filled version of the mask for partial input.
 */
export function formatBrPhone(raw: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, 11);

  if (digits.length === 0) {
    return '';
  }

  if (digits.length <= 2) {
    return `(${digits}`;
  }

  const ddd = digits.slice(0, 2);
  const rest = digits.slice(2);

  if (rest.length <= 4) {
    return `(${ddd}) ${rest}`;
  }

  const suffix = rest.slice(-4);
  const prefix = rest.slice(0, rest.length - 4);
  return `(${ddd}) ${prefix}-${suffix}`;
}

/**
 * Validates a BR phone number: true only when the input has exactly 10 or 11
 * digits once formatting characters are stripped.
 */
export function isValidBrPhone(raw: string): boolean {
  const digits = raw.replace(/\D/g, '');
  return digits.length === 10 || digits.length === 11;
}
